module.exports = __webpack_public_path__ + "static/debug-d503db1732b0a573e1aab1460aa27e3c.png";